module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAABGdBTUEAALGPC/xhBQAAATRJREFUaAXtmVEKwzAMQ+eephcb7EiDXqw9zJbFBZfQb8sTrQYjaT4USa/bj+1R/FnX9W1mT7+2tbbM8/yqtDBVXuZ3edgedPJvBK/0UB7Yg0bAcR9n6PW4HH0Ri74Cs5BA+RBhVLMsuiLMQgLlQ4RRzbLoijALCZQPEUY1y6IrwiwkUD5EGNUsi64Is5BA+RBhVLMsuiLMQgLlQ4RRzbLoWsx6/jEFqCyhj3W+PeNi27Z9rh42ivXQ9/sN75h78mjhquvxSlcH7P8Zbbyzz4dtfEbv7/dKoxtl0xdhNiLZfkQ4u1E2PRFmI5LtR4SzG2XTE2E2Itl+RDi7UTY9EWYjku1HhLMbZdMTYTYi2X5EOLtRNj0RZiOS7UeEsxs96/nII87GfZyh13LCMcuKWQ864Fn/B7dWQE9JKePdAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Home/Combined Shape2.png
// module id = tYDw
// module chunks = 1